<script setup>
import Confirm from "@/components/confirm/Confirm.vue";
import Alert   from  '@/components/common/Alert.vue';
import Share   from  '@/components/confirm/Share.vue';
</script>
<template>
	<Confirm ref="cnfrm" v-if="doc_id != '' && uuid != ''" />
	<Share v-on:docsave="docsave"  v-else-if ="doc_id != '' && uuid == ''" />
	<v-card v-else flat>
		<v-card-text>
    <Alert
        message="赤入れ機能はリリース文書のデータが保存されていなければ利用できません"
        messagetitle="リリースが保存されていません"
        messagetype="2"
        blockheight="80vh"
    />
			
		</v-card-text>
	</v-card>
</template>
<script>
export default {
	computed : {
		doc_id : function(){
			return this.$store.getters['doc_info/get_doc_id'];
		},
		uuid : function(){
			return this.$store.getters['doc_info/get_uuid'];
		},
	},
	methods :{
		updated : function(blockid){
			this.$refs.cnfrm.selected_id_update(blockid);
		},
		docsave : function(){
			this.$emit("docsave");
		},
	},
	created : function(){
	},
}
</script>
